import { useState } from "react";
import { ChevronDown, ChevronRight, Wrench } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useChatExecution } from "@stockline/web";
import type { ChatLogEntry } from "@/app/api/types/chat-sessions";
import { deriveItems, ProcessingItems } from "./ProcessingBubble";

interface MessageToolsFooterProps {
  readonly executionId: string;
  readonly isStatsMode: boolean;
}

export function MessageToolsFooter({
  executionId,
  isStatsMode,
}: MessageToolsFooterProps) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const execution = useChatExecution(executionId);

  const logs = (execution?.logs ?? []) as unknown as ChatLogEntry[];
  const { items } = deriveItems(logs, isStatsMode, t);
  const toolItems = items.filter((i) => i.kind === "step");
  const toolCount = toolItems.length;

  if (toolCount === 0) return null;

  return (
    <div className="flex flex-col items-start gap-1 w-full">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors rounded-full px-3 py-1"
        aria-expanded={expanded}
      >
        {expanded ? (
          <ChevronDown className="h-3.5 w-3.5 flex-shrink-0" />
        ) : (
          <ChevronRight className="h-3.5 w-3.5 flex-shrink-0" />
        )}
        <Wrench className="h-3 w-3 flex-shrink-0" />
        <span>{t("ai.toolsUsed", { count: toolCount })}</span>
      </button>
      {expanded && (
        <div className="flex flex-col items-start gap-1 w-full">
          <ProcessingItems
            items={toolItems}
            isStatsMode={false}
            groupTools={false}
            showRunningSpinner={false}
          />
        </div>
      )}
    </div>
  );
}
